export const countryToCurrencyMap = {
  AFN: "AF",
  EUR: "EU",
  ALL: "AL",
  DZD: "DZ",
  USD: "US",
  AOA: "AO",
  XCD: "AG",
  ARS: "AR",
  AMD: "AM",
  AWG: "AW",
  SHP: "AC",
  AUD: "AU",
  AZN: "AZ",
  BSD: "BS",
  BHD: "BH",
  BDT: "BD",
  BBD: "BB",
  BYN: "BY",
  BZD: "BZ",
  XOF: "BJ",
  BMD: "BM",
  BTN: "BT",
  BOB: "BO",
  BAM: "BA",
  BWP: "BW",
  NOK: "BV",
  BRL: "BR",
  BND: "BN",
  BGN: "BG",
  BIF: "BI",
  CVE: "CV",
  KHR: "KH",
  XAF: "CM",
  CAD: "CA",
  KYD: "KY",
  CLP: "CL",
  CNY: "CN",
  COP: "CO",
  KMF: "KM",
  CDF: "CD",
  NZD: "CK",
  CRC: "CR",
  HRK: "HR",
  CUC: "CU",
  ANG: "CW",
  CZK: "CZ",
  DKK: "DK",
  DJF: "DJ",
  DOP: "DO",
  EGP: "EG",
  SVC: "SV",
  ERN: "ER",
  SZL: "SZ",
  ETB: "ET",
  FKP: "FK",
  FJD: "FJ",
  GMD: "GM",
  GEL: "GE",
  GHC: "GH",
  GIP: "GI",
  GTQ: "GT",
  GNF: "GN",
  GYD: "GY",
  HNL: "HN",
  HKD: "HK",
  HUF: "HU",
  ISK: "IS",
  INR: "IN",
  IDR: "ID",
  IRR: "IR",
  IQD: "IQ",
  ILS: "IL",
  JMD: "JM",
  JPY: "JP",
  JOD: "JO",
  KZT: "KZ",
  KES: "KE",
  KPW: "KP",
  KRW: "KR",
  KWD: "KW",
  KGS: "KG",
  LAK: "LA",
  LBP: "LB",
  LRD: "LR",
  CHF: "CH",
  MOP: "MO",
  MKD: "MK",
  MGA: "MG",
  MWK: "MW",
  MYR: "MY",
  MVR: "MV",
  MRU: "MR",
  MUR: "MU",
  MXN: "MX",
  MDL: "MD",
  MNT: "MN",
  MAD: "MA",
  MZN: "MZ",
  MMK: "MM",
  NAD: "NA",
  NPR: "NP",
  NIO: "NI",
  NGN: "NG",
  PKR: "PK",
  PAB: "PA",
  PGK: "PG",
  PYG: "PY",
  PEN: "PE",
  PHP: "PH",
  PLN: "PL",
  QAR: "QA",
  RON: "RO",
  RUB: "RU",
  RWF: "RW",
  WST: "WS",
  STN: "ST",
  SAR: "SA",
  SCR: "SC",
  SLE: "SL",
  SGD: "SG",
  SBD: "SB",
  SOS: "SO",
  ZAR: "ZA",
  SSP: "SS",
  LKR: "LK",
  SDG: "SD",
  SRD: "SR",
  SEK: "SE",
  SYP: "SY",
  TWD: "TW",
  TJS: "TJ",
  TZS: "TZ",
  THB: "TH",
  TOP: "TO",
  TTD: "TT",
  TND: "TN",
  TRY: "TR",
  TMT: "TM",
  UGX: "UG",
  UAH: "UA",
  AED: "AE",
  UYU: "UY",
  UZS: "UZ",
  VUV: "VU",
  VEB: "VE",
  VND: "VN",
  YER: "YE",
  ZMW: "ZM",
  ZWL: "ZW",
};
